import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
    Banner,
    BodyLargeRegular,
    BodyLargeMedium,
    Button,
    ButtonStack,
    Checkbox,
    DisplaySmall,
    ItemList,
    ItemListItem,
    TextButton,
} from 'prospect-path-base';
import {
    ControlledTooltip,
    Tooltip,
    TooltipContent,
    TooltipTitle,
    TooltipDismissButton,
} from 'prospect-path-components';

import DefaultContainer from '../../components/register/Container';
import Header from '../../components/register/Header';

import CreateTeamModal from '../../components/register/modals/CreateTeamModal';
import TeamModal from '../../components/register/modals/TeamModal';

import Image from '../../images/header.png';
import createTeam from '../../actions/CreateTeam';
import joinTeams from '../../actions/JoinTeams';


const Container = styled(DefaultContainer)`
  flex-direction: column;
`

const Title = styled(DisplaySmall)`
  margin-bottom: 0.25rem;
`

const Content = styled.div`
  max-width: 25rem;
  display: flex;
  margin: auto;
`

class JoinTeam extends Component {
    constructor(props) {
        super(props)

        this.state = {
            visible: false,
            createTeamModalOpen: false,
            teamModalOpen: false,
            userTeams: null,
            newTeams: [],
            showNoTeamSelectedBanner: false,
            data: {
                title: '',
                subtitle: '',
                action: '',
            },
            joinTeamModal: null,
        }

        this.openTooltip = this.openTooltip.bind(this);
        this.closeTooltip = this.closeTooltip.bind(this);
        this.toggleCreateTeamModalOpen = this.toggleCreateTeamModalOpen.bind(this);
        this.handleCreateTeamButtonSubmit = this.handleCreateTeamButtonSubmit.bind(this);
        this.completeSignup = this.completeSignup.bind(this);
        this.openJoinTeamModal = this.openJoinTeamModal.bind(this);
        this.closeJoinTeamModal = this.closeJoinTeamModal.bind(this);
        this.handleJoinTeamModalClose = this.handleJoinTeamModalClose.bind(this);
    }
    componentDidMount() {
        document.title = 'Join a team | Prospect Path';
    }
    openTooltip() {
        this.setState({ visible: true });
    }
    closeTooltip() {
        this.setState({ visible: false });
    }
    toggleCreateTeamModalOpen() {
        this.setState({ createTeamModalOpen: !this.state.createTeamModalOpen });
    }
    handleCreateTeamButtonSubmit(newTeamName) {
        this.setState({
            newTeams: [...this.state.newTeams, newTeamName],
            createTeamModalOpen: false,
        });
    }
    checkboxIsChecked(team) {
        if (this.state.userTeams === null) {
            return this.props.teams.userTeams.includes(team.id);
        }
        return this.state.userTeams.includes(team.id);
    }
    handleCheckboxIsChecked(team) {
        let currentUserTeams = this.state.userTeams;
        if (currentUserTeams === null) {
            currentUserTeams = [...this.props.teams.userTeams];
        }
        const index = currentUserTeams.indexOf(team.id);
        if (index === -1) {
            currentUserTeams.push(team.id);
        } else {
            currentUserTeams.splice(index, 1);
        }
        this.setState({
            userTeams: currentUserTeams,
            showNoTeamSelectedBanner: currentUserTeams.length === 0 && this.state.newTeams.length === 0,
        });
    }
    completeSignup() {
        const hasSelectedTeams = Array.isArray(this.state.userTeams) && this.state.userTeams.length > 0;
        const hasNewTeams = this.state.newTeams.length > 0;
        if(!hasSelectedTeams && !hasNewTeams) {
            this.setState({ showNoTeamSelectedBanner: true});
            return;
        }
        if (hasSelectedTeams || hasNewTeams) {
            const actions = [];

            if (hasSelectedTeams) {
                actions.push(this.props.joinTeams(this.state.userTeams));
            }
            this.state.newTeams.forEach(newTeamName => {
                actions.push(this.props.createTeam(newTeamName))
                  .then(() => {
                      // Remove the new teams from the array as they are created so
                      // that duplicates don't appear for the user
                      this.setState({
                          newTeams: this.state.newTeams.filter(currentName => currentName !== newTeamName),
                      });
                });
            });

            Promise.all(actions)
                .then(() => window.location = '/products');
        } else {
            window.location = '/products';
        }
        this.props.joinTeams(this.state.userTeams)
          .then(() => window.location = '/home');
    }
    openJoinTeamModal(team) {
        this.setState({
            joinTeamModal: team,
        });
    }
    closeJoinTeamModal() {
        this.setState({ joinTeamModal: null });
    }
    handleJoinTeamModalClose(team) {
        let currentUserTeams = this.state.userTeams;
        if (currentUserTeams === null) {
            currentUserTeams = [...this.props.teams.userTeams];
        }
        const index = currentUserTeams.indexOf(team.id);
        if (index === -1) {
            currentUserTeams.push(team.id);
        }

        this.setState({
            userTeams: currentUserTeams,
            showNoTeamSelectedBanner: currentUserTeams.length === 0 && this.state.newTeams.length === 0,
            joinTeamModal: null,
        });
    }
    render() {
        if (this.props.user.id === null) {
            window.location = '/login?redirect=/signup/teams';
        }

        // If the user is already in a team then don't show the join team step and
        // move straight to the home page
        if (this.props.teams.userTeams.length > 0) {
            window.location = '/home';
        }

        if (this.props.inactive) {
            return (
                <Container>
                    <Header showLogInButton={false} />
                    <Content>
                        <div style={{height:740}}>
                            <Title as="h1">Team is inactive</Title>
                            <BodyLargeRegular as="div">
                                Your team has been deactivated. If you have any questions about accessing Prospect Path please contact
                                {' '}<a href="mailto:customerteam@prospectpath.com">customerteam@prospectpath.com</a>
                            </BodyLargeRegular>
                        </div>
                    </Content>
                </Container>
            );
        }

        return (
            <Container>
                <Header showLogInButton={false} />

                <Content>
                    <div>
                        { this.state.showNoTeamSelectedBanner &&
                            <Banner
                                reference="no_team_selected"
                                type="error"
                                title="No Team Selected"
                                body="You must create or select a team before completing sign up"
                                closeable={false}
                            />
                         }

                        <Title as="h1">Join a team</Title>

                        <BodyLargeRegular as="div">
                            {
                                this.props.teams.all.length > 0 ?
                                  "We found some existing teams from your company. Join them or create a new team. " :
                                  'Click "Create new team" below to create a team'
                            }

                            <span style={{ display: 'inline-block' }}>
                                <ControlledTooltip
                                    visible={this.state.visible}
                                    placement="bottom"
                                    tooltip={(
                                        <Tooltip
                                            onMouseLeave={this.closeTooltip}
                                            image={<img src={Image} style={{ width: '100%' }} />}
                                            title={<TooltipTitle>Teams</TooltipTitle>}
                                            content={(
                                                <TooltipContent>
                                                    Teams help you organise user access and billing. You can always join or create more teams later.
                                                </TooltipContent>
                                            )}
                                            dismiss={<TooltipDismissButton onClick={() => window.open('https://support.prospectpath.com/', '_blank')}>More info</TooltipDismissButton>}
                                        />
                                    )}
                                >
                                  <TextButton onMouseEnter={this.openTooltip}>Learn more</TextButton>
                                </ControlledTooltip>
                            </span>
                        </BodyLargeRegular>

                        <ItemList>
                            {this.props.teams.all.map(team => (
                                <ItemListItem
                                    title={<BodyLargeMedium>{team.name}</BodyLargeMedium>}
                                    subtitle={<TextButton onClick={() => this.openJoinTeamModal(team)}>Manages {team.products.length} products</TextButton>}
                                    action={<Checkbox
                                      checked={this.checkboxIsChecked(team)}
                                      onChange={() => this.handleCheckboxIsChecked(team)}
                                    />}
                                />
                            ))}
                            {this.state.newTeams.map(teamName => (
                              <ItemListItem
                                title={<BodyLargeMedium>{teamName}</BodyLargeMedium>}
                                subtitle={<TextButton>Manages 0 products</TextButton>}
                                action={<Checkbox
                                  checked={true}
                                />}
                              />
                            ))}
                        </ItemList>

                        <ButtonStack>
                            <Button
                                size="small"
                                color="secondary"
                                onClick={this.toggleCreateTeamModalOpen}
                            >
                                Create new team
                            </Button>
                            <Button
                              size="small"
                              color="primary"
                              onClick={this.completeSignup}
                            >
                                Complete sign up
                            </Button>
                        </ButtonStack>
                    </div>
                </Content>

                <CreateTeamModal
                    isOpen={this.state.createTeamModalOpen}
                    onCloseButtonClicked={this.toggleCreateTeamModalOpen}
                    onCreateTeamButtonClicked={this.handleCreateTeamButtonSubmit}
                />
                <TeamModal
                    isOpen={this.state.joinTeamModal != null}
                    closeTeamModal={this.closeJoinTeamModal}
                    checkTeam={this.handleJoinTeamModalClose}
                    team={this.state.joinTeamModal}
                    user={this.props.user}
                />
            </Container>
        )
    }
}

const mapStateToProps = state => ({
    user: state.user,
    teams: state.teams,
});
const mapDispatchToProps = dispatch => ({
    createTeam: newTeamName => dispatch(createTeam(newTeamName)),
    joinTeams: teamIds => dispatch(joinTeams(teamIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JoinTeam);
